import AdminLayout from '@/admin/layout/AdminLayout.vue';

const adminRoutes = [
    {
        path: '/admin/login',
        name: 'AdminLogin',
        component: () => import('@/admin/views/LoginView.vue'),
        meta: { title: '管理员登录' },
    },
    {
        path: '/admin',
        component: AdminLayout,
        redirect: '/admin/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'AdminDashboard',
                component: () => import('@/admin/views/DashboardView.vue'),
                meta: { title: '仪表盘' },
            },
            {
                path: 'products',
                name: 'AdminProducts',
                component: () => import('@/admin/views/ProductManage.vue'),
                meta: { title: '产品管理' },
            },
            {
                path: 'project-cases',
                name: 'AdminProjectCases',
                component: () => import('@/admin/views/ProjectCaseManage.vue'),
                meta: { title: '项目案例' },
            },
            {
                path: 'articles',
                name: 'AdminArticles',
                component: () => import('@/admin/views/ArticleManage.vue'),
                meta: { title: '文章管理' },
            },
            {
                path: 'advantages',
                name: 'AdminAdvantages',
                component: () => import('@/admin/views/AdvantageManage.vue'),
                meta: { title: '优势管理' },
            },
            {
                path: 'examples',
                name: 'AdminExamples',
                component: () => import('@/admin/views/ExampleManage.vue'),
                meta: { title: '案例管理' },
            },
            {
                path: 'about',
                name: 'AdminAbout',
                component: () => import('@/admin/views/AboutManage.vue'),
                meta: { title: '关于我们' },
            },
            {
                path: 'inquiries',
                name: 'AdminInquiries',
                component: () => import('@/admin/views/InquiryManage.vue'),
                meta: { title: '询价管理' },
            },
            {
                path: 'users',
                name: 'AdminUsers',
                component: () => import('@/admin/views/UserManage.vue'),
                meta: { title: '管理员管理' },
            },
        ],
    },
];

export default adminRoutes;
